import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "8. Эскизный проект конструкций", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, " 8.1 Подгрузите первую страницу эскизного проекта ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, " 8.2 Подгрузите вторую страницу эскизного проекта ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, " 8.3 Подгрузите третью страницу эскизного проекта ", -1)
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!
  const _component_v_file_uploader = _resolveComponent("v-file-uploader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (_openBlock(), _createBlock(_component_v_file_uploader, {
        main_title: 'На ней изображён главный вид, сверху, снизу и сзади',
        url_file: _ctx.storeDM.save_obj.sketch_project_one_file,
        sample_title: 'Пример первой страницы эскизного проекта',
        sample_file: '11_1.png',
        file_name: 'sketch_project_one_file',
        button_title: 'Подгрузить первую страницу',
        onFileUpload: _ctx.fileUpload,
        key: _ctx.sketch_project_one_file
      }, null, 8, ["url_file", "sample_file", "onFileUpload"])),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      (_openBlock(), _createBlock(_component_v_file_uploader, {
        main_title: 'На ней изображён вид сбоку, слева, способы крепления и характеристики конструкции',
        url_file: _ctx.storeDM.save_obj.sketch_project_two_file,
        sample_title: 'Пример второй страницы эскизного проекта',
        sample_file: '11_2.png',
        file_name: 'sketch_project_two_file',
        button_title: 'Подгрузить вторую страницу',
        onFileUpload: _ctx.fileUpload,
        key: _ctx.sketch_project_two_file
      }, null, 8, ["url_file", "sample_file", "onFileUpload"])),
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      (_openBlock(), _createBlock(_component_v_file_uploader, {
        main_title: 'На ней изображёно фото объекта с конструкцией',
        url_file: _ctx.storeDM.save_obj.sketch_project_three_file,
        sample_title: 'Пример третьей страницы эскизного проекта',
        sample_file: '11_3.png',
        file_name: 'sketch_project_three_file',
        button_title: 'Подгрузить третью страницу',
        onFileUpload: _ctx.fileUpload,
        key: _ctx.sketch_project_three_file
      }, null, 8, ["url_file", "sample_file", "onFileUpload"]))
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_14)
  ], 64))
}